import { useLayoutEffect } from "react";
import { StaleMessages } from "../../models/messages/Messages";
import Model from "../../models/Model";
import "../../styles/stale/staleAlert.css";
import { Button } from "../buttons/Button";

export { StaleModel };
type Props = {
  model?: Model;
  onConfirm: (loadNewModel: boolean) => void;
};

const StaleModel = (props: Props) => {
  if (!props.model || !props.model.stale) {
    return null;
  }

  /* Always scroll so this component is visible */
  useLayoutEffect(() => {
    document
      .getElementsByClassName("staleAlert model")[0]
      ?.scrollIntoView(true);
  });

  return (
    <div className={"staleAlert model"}>
      <h3>New Template Version Available</h3>
      <div>
        <span>{StaleMessages.staleModel()}</span>
        <div className={"fluffer"} />
        <div className={"buttons"}>
          <Button
            data-reload
            onClick={() => {
              props.onConfirm(true);
            }}
          >
            Update Model
          </Button>
          <Button
            data-ignore
            onClick={() => {
              props.onConfirm(false);
            }}
          >
            Ignore
          </Button>
        </div>
      </div>
    </div>
  );
};
